import { createPortal } from 'react-dom';

import type { FCC } from '../../types/common';
import { fullscreenElementOrBody } from '../../utils/fullscreen_element_or_body';
import { ui } from '../../utils/helpers';

import styles from './panel_widget.module.css';

type PanelWidgetProps = {
  panelId: string;
};

const PanelWidget: FCC<PanelWidgetProps> = (props) => {
  const { children, panelId } = props;
  return createPortal(
    <div className={styles.root} {...ui({ widget: panelId })}>
      {children}
    </div>,
    fullscreenElementOrBody(),
  );
};

export default PanelWidget;
